import { getCurrentStyle, setCurrentStyle, changeTheme } from '@/util/theme'
const currentStyle = getCurrentStyle() || {}
const defaultStyle = {
  layout: 'tl',
  sidebar: 'simple',
  theme: 'light',
  tagbar: false,
  lingxi: false,
}

const state = {
  // 系统样式
  // systemStyle: {
  //   theme: 'light',
  // },
 
   // 系统样式
  systemStyle: {
    // 布局类型 tl: 先上后左(上左+主体布局); lt: 先左后上(左上+主体布局)
    layout: currentStyle.layout || defaultStyle.layout,
    // 侧边栏类型 simple: 折叠导航菜单; collapse: 收缩导航菜单; mix: 混合导航菜单
    sidebar: currentStyle.sidebar || defaultStyle.sidebar,
    // 主题风格
    theme: currentStyle.theme || defaultStyle.theme,
    // 移动端导航是否打开
    mobileSidebar: false,
    // 当前侧边栏class
    sidebarClass: '',
    // 是否显示tagbar
    tagbar: currentStyle.tagbar || defaultStyle.tagbar,
  },
  // 系统尺寸
  systemSize: {
    // 设备类型（根据宽度计算，移动端/桌面端）
    deviceType: 'desktop',
    // 设备宽度（es/xs/sm/md/lg）
    deviceWidth: 'lg',
    // 主体部分宽度（es/xs/sm/md/lg）
    mainWidth: 'lg'
  },
  // 系统尺寸
  systemOther: {
    // 是否显示AI助手
    lingxi: currentStyle.lingxi || defaultStyle.lingxi
  },
  fontSize: '16px',
}

const mutations = {
  setFont(state, value) {
    state.fontSize = value
  },
  // 更新布局类型
  updateLayoutType (state, props) {
    state.systemStyle.layout = props || defaultStyle.layout
    setCurrentStyle(state.systemStyle)
  },
  // 更新侧边栏风格
  updateSidebarType (state, props) {
    state.systemStyle.sidebar = props || defaultStyle.sidebar
    setCurrentStyle(state.systemStyle)
  },
  // 更新页面主题
  updateTheme (state, props) {
    state.systemStyle.theme = props || defaultStyle.theme
    changeTheme(props || defaultStyle.theme)
    setCurrentStyle(state.systemStyle)
  },
  // 设置设备类型
  updateDeviceType (state, props) {
    state.systemSize.deviceType = props
  },
  // 设置设备宽度类型
  updateDeviceWidth (state, props) {
    state.systemSize.deviceWidth = props
  },
  // 设置主体宽度类型
  updateMainWidth (state, props) {
    state.systemSize.mainWidth = props
  },
  // 设置移动端侧边栏的打开/收起
  setMobileSidebar (state, props) {
    state.systemStyle.mobileSidebar = props
  },
  // 设置当前侧边栏class，需要存入store中，用于图表、栅格等的自适应计算
  setSidebarClass (state, className) {
    state.systemStyle.sidebarClass = className
  },
  // 设置是否显示页签
  updateTagbarState (state, props) {
    state.systemStyle.tagbar = props
    setCurrentStyle(state.systemStyle)
  },
  // 设置是否显示AI小助手
  updateLingxiState (state, props) {
    state.systemOther.lingxi = props
    setCurrentStyle(state.systemOther)
  }
}

const actions = {
  toggleFontSize({ commit }) {
    if (state.fontSize === '16px') {
      commit('setFont', '19px')
    } else {
      commit('setFont', '16px')
    }
  },
  adjustElementSize() {
    const appElement = document.getElementById("app");
    if (!appElement) return;
    const windowWidth = window.innerWidth;

    const baseWidth = 1980;

    const widthRatio = windowWidth / baseWidth;

    if (widthRatio > 1) {
      appElement.style.zoom = widthRatio * 0.96;
    } else {
      appElement.style.zoom = widthRatio * 1.05;
    }
  },
  addEventListener() {
    window.addEventListener("resize", this.adjustElementSize);
  },
  removeEventListener() {
    window.removeEventListener("resize", this.adjustElementSize);
  },
}
const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
